const LinkExternal = ({
  href,
  children,
  className = "",
  label = "",
  ...rest
}) => {
  return (
    <a className={className} href={href} aria-label={label} {...rest}>
      {children}
    </a>
  );
};

export default LinkExternal;
